module.exports = __webpack_public_path__ + "static/media/jan-sendereks.04f03901.jpg";